export default __webpack_public_path__ + "static/media/delete-3.1261cb41.svg";